import React, { useEffect, useState } from 'react';
import { string, object, bool, array, number } from 'prop-types';
import { differenceInMinutes } from 'date-fns';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '../Typography';
import messages from './messages';

export const useStyles = makeStyles({
  containerL: {
    height: 70,
  },
  container: {
    height: 160,
  },
  infoL: {
    position: 'relative',
    top: -58,
  },
  info: {
    position: 'relative',
    top: -140,
  },
  minutes: {
    fontSize: 14,
    lineHeight: 1,
    marginTop: 2,
  },
  numberL: {
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: 1,
    marginBottom: 2,
  },
  number: {
    fontSize: 50,
    lineHeight: 1,
    marginBottom: 4,
  },
  numberLRange: {
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 1.5,
  },
});

const stylesInline = {
  active: { color: 'green' },
  inactive: { color: 'grey' },
};

const MyCircularProgress = ({
  className,
  size = 'medium',
  time,
  live,
  active,
  range,
}) => {
  const classes = useStyles();

  const [chrono, setChrono] = useState(0);
  const [chronoEnd, setChronoEnd] = useState(0);

  useEffect(() => {
    let mounted = true;

    if (Array.isArray(range) && range.length === 2) {
      setChrono(range[0]);
      setChronoEnd(range[1]);
    } else if (time != null) {
      const initial =
        typeof time === 'number'
          ? time
          : differenceInMinutes(time, new Date());
      setChrono(initial);
    }

    const timer = setInterval(() => {
      if (!mounted) return;
      if (Array.isArray(range) && range.length === 2) {
        setChrono((c) => Math.max(0, c - 1));
        setChronoEnd((e) => Math.max(0, e - 1));
      } else {
        setChrono((c) => Math.max(0, c - 1));
      }
    }, 60_000);

    return () => {
      mounted = false;
      clearInterval(timer);
    };
  }, [time, range]);

  const isRange = Array.isArray(range) && range.length === 2;
  const isRangeZero = isRange && chrono <= 0 && chronoEnd <= 0;
  const isSingleZero = !isRange && chrono <= 0;

  const displayValue = isRange
    ? `${Math.max(0, chrono)}-${Math.max(0, chronoEnd)}`
    : `${Math.max(0, chrono)}`;

  let numberClass;
  if (size === 'little') {
    numberClass = isRange ? classes.numberLRange : classes.numberL;
  } else {
    numberClass = isRange ? classes.numberLRange : classes.number;
  }

  const colorStyle =
    live && active ? stylesInline.active : stylesInline.inactive;

  const shouldShow = (time != null && !isRange) || isRange;

  return (
    <Grid
      name="CircularProgress"
      className={`
        ${size === 'little' ? classes.containerL : classes.container}
        ${className || ''}
      `}
    >
      <CircularProgress
        size={size === 'little' ? 70 : 160}
        thickness={2}
        style={live ? colorStyle : {}}
      />

      {shouldShow && (
        <Grid
          container
          direction="column"
          alignItems="center"
          className={size === 'little' ? classes.infoL : classes.info}
          data-testid={isRange ? 'range' : 'chrono'}
        >
          {isRangeZero || isSingleZero ? (
            <>
              <Typography
                className={
                  size === 'little' ? classes.numberL : classes.number
                }
                style={colorStyle}
                color="primary"
                content={0}
              />
              <Typography
                className={classes.minutes}
                style={colorStyle}
                color="primary"
                content={messages.minutes}
              />
            </>
          ) : (
            <>
              <Typography
                className={numberClass}
                style={colorStyle}
                color="primary"
                content={displayValue}
              />
              <Typography
                className={classes.minutes}
                style={colorStyle}
                color="primary"
                content={messages.minutes}
              />
            </>
          )}
        </Grid>
      )}
    </Grid>
  );
};

MyCircularProgress.propTypes = {
  className: string,
  size: string,
  time: object || number,
  live: bool,
  active: bool,
  range: array,
};

export default MyCircularProgress;